import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../shared/services/alert.service';
import { ApiService } from '../../shared/services/api.service';
import { FormControlService } from '../../shared/services/form-control.service';
import { File } from '../../models/files/files.model';
import { Contained } from '../../models/editors/contained.model';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-logo',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})
export class LogoComponent extends InlineFormBase<File> implements OnInit {
  public url = 'logo';
  public headerTitle = 'Logo';
  public get fieldsConfig(): Array<any> {
    return [
      new Contained({
        key: 'file_id',
        label: 'Logo',
        entity: this.entity,
        upload: true,
        isHalf: true,
        imgOnly: true
      })
    ];
  }
  public FormEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }
}
